import { ClientConfig } from "@ccp/client-config";
import axios from "axios";

export const getConfig = (clientId: string) => {
    return axios.get<ClientConfig>(`/app-config/${clientId}`).then(({ data }) => data);
};